import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = {
  key: 0,
  class: "error-container"
}
const _hoisted_5 = {
  key: 1,
  class: "computing-container"
}
const _hoisted_6 = {
  key: 2,
  class: "loading-container"
}
const _hoisted_7 = {
  key: 3,
  class: "empty-container"
}
const _hoisted_8 = {
  key: 4,
  class: "analysis-content"
}
const _hoisted_9 = { class: "student-group" }
const _hoisted_10 = {
  key: 0,
  class: "no-data"
}
const _hoisted_11 = {
  key: 1,
  class: "student-list"
}
const _hoisted_12 = { class: "student-name" }
const _hoisted_13 = { class: "student-score" }
const _hoisted_14 = { class: "student-group" }
const _hoisted_15 = {
  key: 0,
  class: "no-data"
}
const _hoisted_16 = {
  key: 1,
  class: "student-list"
}
const _hoisted_17 = { class: "student-name" }
const _hoisted_18 = { class: "student-score" }
const _hoisted_19 = { class: "grade-category excellent-category" }
const _hoisted_20 = { class: "count" }
const _hoisted_21 = { class: "grade-category warning-category" }
const _hoisted_22 = { class: "count" }
const _hoisted_23 = { class: "grade-category danger-category" }
const _hoisted_24 = { class: "count" }
const _hoisted_25 = { class: "pass-rate-item" }
const _hoisted_26 = { class: "rate" }
const _hoisted_27 = { class: "pass-rate-item" }
const _hoisted_28 = { class: "rate" }
const _hoisted_29 = { class: "pass-rate-item" }
const _hoisted_30 = { class: "rate" }
const _hoisted_31 = { class: "pass-rate-item" }
const _hoisted_32 = { class: "rate" }

import { onMounted, ref, computed, onUnmounted } from "vue";
import { class_info } from "@/views/teacher/types";
import { getClassesApi } from "@/servers/api/classes";
import { 
  message, 
  Card, 
  Row, 
  Col, 
  Spin, 
  Empty, 
  Statistic, 
  Divider,
  Button,
  Alert
} from "ant-design-vue";
import { 
  LikeOutlined,
  DislikeOutlined,
  RiseOutlined,
  TeamOutlined,
  RedoOutlined
} from '@ant-design/icons-vue';
import { useUserStore } from "@/store";
import { 
  postClassAlwaysTopBottomStudents,
  postClassAnalysis,
  postClassComprehensiveStudentGrades,
  postClassCompute,
  postClassPassLineRate
} from "@/servers/api/average";

// 状态管理

export default /*@__PURE__*/_defineComponent({
  __name: 'ComAnalysisSimple',
  setup(__props) {

const userStore = useUserStore();
const classInfo = ref<class_info>();
const loading = ref(false);
const computing = ref(false);
const pollTimer = ref<number | null>(null);
const errorMessage = ref("");

// 数据存储
const topBottomStudents = ref<any[]>([]);
const classAnalysisData = ref<any>({});
const studentGradesData = ref<any[]>([]);
const passLineRateData = ref<any>({});

// 计算属性
const hasData = computed(() => {
  return (
    topBottomStudents.value.length > 0 ||
    Object.keys(classAnalysisData.value).length > 0 ||
    studentGradesData.value.length > 0 ||
    Object.keys(passLineRateData.value).length > 0
  );
});

// 获取教师ID
const getTeacherId = () => {
  const userInfo = userStore.getUserInfo();
  return String(userInfo?.role || userInfo?.teacher?.uid || '').trim();
};

// 初始化班级信息
const initClassInfo = async () => {
  try {
    const teacherId = getTeacherId();
    if (!teacherId) {
      message.error("未获取到教师信息");
      errorMessage.value = "未获取到教师信息";
      return;
    }

    let classData: any[] = [];
    const classRes = await getClassesApi({ header: teacherId });
    if (classRes.code === 200 && classRes.data.length > 0) {
      classData = classRes.data;
    }

    // 兼容非班主任教师：回退全班级（可按学校过滤）
    if (classData.length === 0) {
      const allClassRes = await getClassesApi({});
      if (allClassRes.code === 200 && Array.isArray(allClassRes.data)) {
        classData = allClassRes.data;
      }
      if (classData.length > 0) {
        message.warning("未找到班主任绑定班级，已切换为全班级");
      }
    }

    if (classData.length > 0) {
      classInfo.value = {
        header: classData[0].header,
        class_id: classData[0].id,
        name: classData[0].name,
        subject_selection: classData[0].subject_selection,
        school_id: classData[0].school_id
      };
      // 获取班级数据分析
      await fetchClassAnalysisData();
    } else {
      const errorMsg = classRes.msg || "未查询到班级信息";
      message.error(errorMsg);
      errorMessage.value = errorMsg;
    }
  } catch (err: any) {
    const errorMsg = "初始化失败: " + (err?.message || "未知错误");
    message.error(errorMsg);
    errorMessage.value = errorMsg;
    console.error(err);
  }
};

// 获取班级经常排名靠前或靠后的学生
const fetchTopBottomStudents = async (): Promise<boolean> => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    const res = await postClassAlwaysTopBottomStudents({
      class_ids: [classInfo.value.class_id]
    });
    
    if (res.code === 200 && res.data) {
      topBottomStudents.value = res.data;
      return res.data.length > 0;
    }
    return false;
  } catch (err: any) {
    console.error("获取班级排名学生数据失败:", err);
    message.error("获取班级排名学生数据失败: " + (err?.message || "网络错误"));
    return false;
  }
};

// 获取班级成绩综合分析
const fetchClassAnalysis = async (): Promise<boolean> => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    const res = await postClassAnalysis({
      class_ids: [classInfo.value.class_id]
    });
    
    if (res.code === 200 && res.data) {
      classAnalysisData.value = res.data;
      return Object.keys(res.data).length > 0;
    }
    return false;
  } catch (err: any) {
    console.error("获取班级成绩综合分析失败:", err);
    message.error("获取班级成绩综合分析失败: " + (err?.message || "网络错误"));
    return false;
  }
};

// 获取学生分类数据（优等生、边缘生、差生）
const fetchStudentGrades = async (): Promise<boolean> => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    const res = await postClassComprehensiveStudentGrades({
      class_ids: [classInfo.value.class_id]
    });
    
    if (res.code === 200 && res.data) {
      studentGradesData.value = res.data;
      return res.data.length > 0;
    }
    return false;
  } catch (err: any) {
    console.error("获取学生分类数据失败:", err);
    message.error("获取学生分类数据失败: " + (err?.message || "网络错误"));
    return false;
  }
};

// 获取班级四条分数线过线率
const fetchPassLineRate = async (): Promise<boolean> => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    const res = await postClassPassLineRate({
      class_ids: [classInfo.value.class_id]
    });
    
    if (res.code === 200 && res.data) {
      passLineRateData.value = res.data;
      return Object.keys(res.data).length > 0;
    }
    return false;
  } catch (err: any) {
    console.error("获取过线率数据失败:", err);
    message.error("获取过线率数据失败: " + (err?.message || "网络错误"));
    return false;
  }
};

// 触发后台计算
const triggerClassCompute = async () => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    computing.value = true;
    const res = await postClassCompute({
      class_id: classInfo.value.class_id
    });
    
    if (res.code === 200) {
      message.info("正在生成中，请稍后查看");
      // 开始轮询检查计算完成状态
      startPolling();
      return true;
    } else {
      const errorMsg = res.msg || "触发计算失败";
      message.error(errorMsg);
      errorMessage.value = errorMsg;
      return false;
    }
  } catch (err: any) {
    const errorMsg = "触发计算异常: " + (err?.message || "网络错误");
    message.error(errorMsg);
    errorMessage.value = errorMsg;
    console.error(err);
    return false;
  } finally {
    computing.value = false;
  }
};

// 开始轮询检查计算完成状态
const startPolling = () => {
  // 先清除已有的定时器
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
  }
  
  message.info("开始检查数据生成状态...");
  
  pollTimer.value = window.setInterval(async () => {
    try {
      // 重新获取所有数据
      await fetchClassAnalysisDataWithoutPolling();
      
      // 检查是否有数据
      if (hasData.value) {
        if (pollTimer.value) {
          clearInterval(pollTimer.value);
          pollTimer.value = null;
          message.success("数据生成完成！");
        }
      }
    } catch (err) {
      console.error("轮询检查失败:", err);
    }
  }, 5000); // 每5秒检查一次
  
  // 设置超时时间，避免无限轮询
  setTimeout(() => {
    if (pollTimer.value) {
      clearInterval(pollTimer.value);
      pollTimer.value = null;
      if (!hasData.value) {
        message.warning("数据生成可能需要更长时间，请稍后手动刷新页面查看");
      }
    }
  }, 60000); // 1分钟后超时
};

// 获取所有班级分析数据（不启动轮询）
const fetchClassAnalysisDataWithoutPolling = async () => {
  if (!classInfo.value?.class_id) return false;
  
  try {
    // 依次尝试调用接口1、2、3和5
    const hasTopBottom = await fetchTopBottomStudents();
    const hasAnalysis = await fetchClassAnalysis();
    const hasGrades = await fetchStudentGrades();
    const hasPassRate = await fetchPassLineRate();
    
    return hasTopBottom || hasAnalysis || hasGrades || hasPassRate;
  } catch (err) {
    console.error("获取班级分析数据失败:", err);
    return false;
  }
};

// 获取所有班级分析数据
const fetchClassAnalysisData = async () => {
  if (!classInfo.value?.class_id) return;
  
  loading.value = true;
  errorMessage.value = "";
  
  try {
    // 依次尝试调用接口1、2、3和5
    const hasTopBottom = await fetchTopBottomStudents();
    const hasAnalysis = await fetchClassAnalysis();
    const hasGrades = await fetchStudentGrades();
    const hasPassRate = await fetchPassLineRate();
    
    // 如果任意一个接口返回的结果为空，则触发后台计算
    if (!hasTopBottom || !hasAnalysis || !hasGrades || !hasPassRate) {
      await triggerClassCompute();
    }
  } catch (err: any) {
    const errorMsg = "获取班级分析数据失败: " + (err?.message || "未知错误");
    message.error(errorMsg);
    errorMessage.value = errorMsg;
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 刷新数据
const refreshData = async () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
  await fetchClassAnalysisData();
};

// 组件挂载
onMounted(async () => {
  await initClassInfo();
});

// 组件卸载时清理定时器
onUnmounted(() => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(classInfo.value?.name) + "班级成绩综合分析", 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: refreshData,
          loading: loading.value,
          disabled: computing.value
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(RedoOutlined))
          ]),
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createTextVNode(" 刷新数据 ", -1))
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_a_alert, {
            message: errorMessage.value,
            type: "error",
            "show-icon": "",
            closable: "",
            onClose: _cache[0] || (_cache[0] = ($event: any) => (errorMessage.value = ''))
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    (computing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_a_alert, {
            message: "正在生成数据...",
            description: "后台正在计算班级成绩综合分析数据，请稍后查看。",
            type: "info",
            "show-icon": ""
          })
        ]))
      : _createCommentVNode("", true),
    (loading.value && !computing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_a_spin, {
            tip: '加载中...',
            size: "large"
          })
        ]))
      : (!hasData.value && !loading.value && !computing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_a_empty, { description: "暂无数据" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: refreshData
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("重新加载", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (hasData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_a_row, {
                gutter: [24, 24],
                class: "stats-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "section-title" }, "班级统计概览", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "stat-card excellent-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_statistic, {
                            title: "优秀学生数量",
                            value: topBottomStudents.value.filter(s => s.type === 'top').length,
                            "value-style": { color: '#3f8600' }
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(LikeOutlined))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "stat-card warning-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_statistic, {
                            title: "待关注学生数量",
                            value: topBottomStudents.value.filter(s => s.type === 'bottom').length,
                            "value-style": { color: '#cf1322' }
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(DislikeOutlined))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "stat-card info-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_statistic, {
                            title: "特控通过率",
                            value: passLineRateData.value.first_line_rate || 0,
                            precision: 2,
                            suffix: "%",
                            "value-style": { color: '#1890ff' }
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(RiseOutlined))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: 24,
                    sm: 12,
                    md: 8,
                    lg: 6
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "stat-card primary-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_statistic, {
                            title: "班级学生总数",
                            value: studentGradesData.value.length,
                            "value-style": { color: '#722ed1' }
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_unref(TeamOutlined))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [24, 24] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "section-title" }, "优秀学生与待关注学生", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "data-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 24,
                                md: 12
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "group-title" }, "优秀学生", -1)),
                                    (topBottomStudents.value.filter(s => s.type === 'top').length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 暂无数据 "))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topBottomStudents.value.filter(s => s.type === 'top'), (student) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: student.id,
                                              class: "student-item excellent-item"
                                            }, [
                                              _createElementVNode("span", _hoisted_12, _toDisplayString(student.name), 1),
                                              _createElementVNode("span", _hoisted_13, _toDisplayString(student.score) + "分", 1)
                                            ]))
                                          }), 128))
                                        ]))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                md: 12
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_14, [
                                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "group-title" }, "待关注学生", -1)),
                                    (topBottomStudents.value.filter(s => s.type === 'bottom').length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 暂无数据 "))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topBottomStudents.value.filter(s => s.type === 'bottom'), (student) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: student.id,
                                              class: "student-item warning-item"
                                            }, [
                                              _createElementVNode("span", _hoisted_17, _toDisplayString(student.name), 1),
                                              _createElementVNode("span", _hoisted_18, _toDisplayString(student.score) + "分", 1)
                                            ]))
                                          }), 128))
                                        ]))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [24, 24] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "section-title" }, "学生分类情况", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "data-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, {
                            gutter: 16,
                            justify: "center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_19, [
                                    _cache[8] || (_cache[8] = _createElementVNode("h3", null, "优等生", -1)),
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(studentGradesData.value.filter(s => s.category === 'excellent').length) + "人", 1),
                                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "description" }, "成绩优异，稳定前列", -1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _cache[10] || (_cache[10] = _createElementVNode("h3", null, "边缘生", -1)),
                                    _createElementVNode("div", _hoisted_22, _toDisplayString(studentGradesData.value.filter(s => s.category === 'borderline').length) + "人", 1),
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "description" }, "成绩波动，需要关注", -1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_23, [
                                    _cache[12] || (_cache[12] = _createElementVNode("h3", null, "差生", -1)),
                                    _createElementVNode("div", _hoisted_24, _toDisplayString(studentGradesData.value.filter(s => s.category === 'poor').length) + "人", 1),
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "description" }, "成绩落后，急需提升", -1))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [24, 24] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("div", { class: "section-title" }, "分数线过线率统计", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { class: "data-card" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 16 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 12,
                                md: 6
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_25, [
                                    _cache[15] || (_cache[15] = _createElementVNode("h4", null, "特控线", -1)),
                                    _createElementVNode("div", _hoisted_26, _toDisplayString((passLineRateData.value.first_line_rate || 0).toFixed(2)) + "%", 1),
                                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "description" }, "重点大学录取线", -1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 12,
                                md: 6
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _cache[17] || (_cache[17] = _createElementVNode("h4", null, "二本线", -1)),
                                    _createElementVNode("div", _hoisted_28, _toDisplayString((passLineRateData.value.second_line_rate || 0).toFixed(2)) + "%", 1),
                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "description" }, "本科录取线", -1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 12,
                                md: 6
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_29, [
                                    _cache[19] || (_cache[19] = _createElementVNode("h4", null, "专科线", -1)),
                                    _createElementVNode("div", _hoisted_30, _toDisplayString((passLineRateData.value.junior_college_line_rate || 0).toFixed(2)) + "%", 1),
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "description" }, "专科录取线", -1))
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 12,
                                md: 6
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_31, [
                                    _cache[21] || (_cache[21] = _createElementVNode("h4", null, "平均分线", -1)),
                                    _createElementVNode("div", _hoisted_32, _toDisplayString((passLineRateData.value.average_line_rate || 0).toFixed(2)) + "%", 1),
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "description" }, "班级平均分", -1))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})